import React, { useState } from 'react';
import { Helix2000Character } from '../../../../shared/CharacterTypes';
import { ConnectionStatus } from './Network/ConnectionStatus';
import { NetworkActions } from './Network/NetworkActions';
import { OnlinePlayers } from './Network/OnlinePlayers';
import { NetworkStats } from './Network/NetworkStats';
import { SystemHealthPanel } from './SystemHealthPanel';

interface ConnectionsToolsTabProps {
  isConnected: boolean;
  otherPlayers: Map<string, Helix2000Character>;
  player: Helix2000Character | null;
  onAction: (action: string, data?: any) => void;
}

export const ConnectionsToolsTab: React.FC<ConnectionsToolsTabProps> = ({
  isConnected,
  otherPlayers,
  player: _player,
  onAction
}) => {
  const [showHealth, setShowHealth] = useState(true);

  return (
    <>
      <ConnectionStatus isConnected={isConnected} />
      <NetworkActions isConnected={isConnected} onAction={onAction} />
      <NetworkStats isConnected={isConnected} />
      <OnlinePlayers otherPlayers={otherPlayers} />

      {/* System Health Section */}
      <div style={{ marginTop: '8px', borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: '8px' }}>
        <button
          onClick={() => setShowHealth(v => !v)}
          style={{
            background: 'none', border: 'none', color: '#aaa', cursor: 'pointer',
            fontSize: '11px', fontFamily: 'monospace', padding: '2px 0',
            display: 'flex', alignItems: 'center', gap: '6px', width: '100%', textAlign: 'left',
          }}
        >
          <span>{showHealth ? '▼' : '▶'}</span>
          <span style={{ fontWeight: 'bold', color: '#ccc' }}>System Health Monitor</span>
        </button>
        {showHealth && <SystemHealthPanel />}
      </div>
    </>
  );
};
